<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M25.0002 15L15.0002 25M15.0002 15L25.0002 25M36.6668 20C36.6668 29.2048 29.2049 36.6667 20.0002 36.6667C10.7954 36.6667 3.3335 29.2048 3.3335 20C3.3335 10.7953 10.7954 3.33334 20.0002 3.33334C29.2049 3.33334 36.6668 10.7953 36.6668 20Z" stroke="#0D0D0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

